/**
 * @file Re-exports the OrganizationUpdateModal component.
 */

import OrganizationUpdateModal from "./OrganizationUpdateModal";

export default OrganizationUpdateModal;
